import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const AllProductsFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const AllProducts = withAppProviders(AllProductsFrontend)();
export default AllProducts;

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-all-products");

	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<AllProducts />
			</Suspense>,
			element
		);
	}
});
